"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT_TYPE = exports.TABLE_LAYOUT = exports.SUBTITLE_POSITION = exports.COLUMNS = exports.BOX_SIZING = exports.ALIGNMENT = void 0;
var TRANSLATION = {
  adult: 'Adult',
  infant: 'Infant',
  child: 'Child',
  guestName: 'Guest',
  bookingNumber: 'Booking Number',
  cabin: 'Cabin',
  checked: 'Checked',
  general: 'general'
};
exports.TRANSLATION = TRANSLATION;
var TEXT_TYPE = {
  title: {
    fontFamily: 'default',
    fontSize: 'normal',
    fontWeight: 'medium',
    lineHeight: 'XLarge',
    fontColor: 'greyDarker'
  },
  text: {
    fontFamily: 'default',
    fontSize: 'normal',
    fontWeight: 'normal',
    lineHeight: 'XLarge',
    fontColor: 'neutral'
  },
  subtitle: {
    fontFamily: 'default',
    fontSize: 'XSmall',
    fontWeight: 'normal',
    lineHeight: 'XLarge',
    fontColor: 'greyDark'
  },
  bookingTitle: {
    fontFamily: 'secondary',
    fontSize: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    fontColor: 'secondary'
  },
  subheader: {
    fontFamily: 'default',
    fontSize: 'small',
    fontWeight: 'normal',
    lineHeight: 'small',
    fontColor: 'charcoalGrey'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var COLUMNS = {
  bookingNumber: 'bookingNumber',
  guestName: 'guestName',
  cabin: 'cabin',
  checked: 'checked',
  date: 'date',
  depart: 'depart',
  arrive: 'arrive',
  status: 'status'
};
exports.COLUMNS = COLUMNS;
var SUBTITLE_POSITION = {
  prefix: 'Prefix',
  postfix: 'Postfix'
};
exports.SUBTITLE_POSITION = SUBTITLE_POSITION;
var ALIGNMENT = {
  right: 'right',
  left: 'left',
  center: 'center'
};
exports.ALIGNMENT = ALIGNMENT;
var BOX_SIZING = {
  borderBox: 'border-box',
  contentBox: 'content-box'
};
exports.BOX_SIZING = BOX_SIZING;
var TABLE_LAYOUT = {
  fixed: 'fixed',
  auto: 'auto'
};
exports.TABLE_LAYOUT = TABLE_LAYOUT;